const ALL_THEME_TYPES = ['default', 'tourney'];
export function isThemeType(str) {
    return ALL_THEME_TYPES.includes(str);
}
